import React from "react";

import styles from "./right-column-main.module.scss";
import MessageListComponent from "./message-list/message-list.component";

const RightColumnMainComponent: React.FC = () => {
  return (
    <div className={styles.rightColumnMain}>
      <MessageListComponent />
    </div>
  );
};

export default RightColumnMainComponent;
